import type { UserDetail } from "~/types/User";
import type { UserSpace } from "~/constants/cookies";

export const useUserStore = defineStore(
  "user",
  () => {
    const user = ref<UserDetail | null>();
    const selectedSpace = ref<UserSpace>(null);

    async function loadUser() {
      user.value = useSanctumUser<UserDetail | null>()?.value;
    }

    async function getUser() {
      if (!user.value) {
        await loadUser();
      }
      return readonly(user);
    }

    function clearUser() {
      user.value = null;
      selectedSpace.value = null;
    }

    function setSelectedSpace(space: UserSpace) {
      selectedSpace.value = space;
    }

    function getSelectedSpace() {
      return selectedSpace.value;
    }

    function clearSelectedSpace() {
      selectedSpace.value = null;
    }

    return {
      user: readonly(user),
      loadUser,
      getUser,
      clearUser,
      selectedSpace: readonly(selectedSpace),
      setSelectedSpace,
      getSelectedSpace,
      clearSelectedSpace,
    };
  },
  {
    persist: {
      storage: piniaPluginPersistedstate.cookies(),
    },
  },
);
